<header class="header">
  <div class="header-container">
    <div class="logo-wrapper">
      <a routerLink="/" class="logo">
        <img src="favicon.svg" alt="Dream Agility Logo" width="32" height="32">
        <span class="logo-divider">•</span>
        <span>Audit Suite</span>
      </a>
      <a href="https://dreamagility.com" target="_blank" rel="noopener noreferrer" class="by-dream-agility">
        by Dream Agility
      </a>
    </div>

    <!-- Desktop actions -->
    <div class="header-actions desktop-only">
      <button routerLink="/contact" class="btn btn-primary">Contact Us</button>
      @if (isLoggedIn) {
        <div class="profile-menu">
          <button class="profile-btn" (click)="toggleMenu()">
            <mat-icon>person</mat-icon>
          </button>
          @if (isMenuOpen) {
            <div class="dropdown-menu">
              <button class="dropdown-item" (click)="manageDetails()">
                <mat-icon>person</mat-icon>
                Manage Account
              </button>
              <button class="dropdown-item" (click)="viewReport()">
                <mat-icon>description</mat-icon>
                View Report
              </button>
              <button class="dropdown-item" (click)="signOut()">
                <mat-icon>logout</mat-icon>
                Sign Out
              </button>
            </div>
          }
        </div>
      } @else if (!isOnLoginPage) {
        <button class="btn btn-secondary" (click)="signIn()">Log In</button>
      }
    </div>

    <!-- Mobile hamburger button -->
    <button class="hamburger-btn mobile-only" (click)="toggleMobileMenu()">
      <mat-icon>{{ isMobileMenuOpen ? 'close' : 'menu' }}</mat-icon>
    </button>
  </div>

  <!-- Mobile menu -->
  @if (isMobileMenuOpen) {
    <div class="mobile-menu">
      <a routerLink="/contact" class="mobile-menu-item" (click)="closeMobileMenu()">
        <mat-icon>mail</mat-icon>
        Contact Us
      </a>
      @if (isLoggedIn) {
        <button class="mobile-menu-item" (click)="manageDetails(); closeMobileMenu()">
          <mat-icon>person</mat-icon>
          Manage Account
        </button>
        <button class="mobile-menu-item" (click)="viewReport(); closeMobileMenu()">
          <mat-icon>description</mat-icon>
          View Report
        </button>
        <button class="mobile-menu-item" (click)="signOut(); closeMobileMenu()">
          <mat-icon>logout</mat-icon>
          Sign Out
        </button>
      } @else if (!isOnLoginPage) {
        <button class="mobile-menu-item" (click)="signIn(); closeMobileMenu()">
          <mat-icon>login</mat-icon>
          Log In
        </button>
      }
    </div>
  }
</header>
